const locale = {
	TAB_OVERVIEW: 'Panoramica',
	TAB_MANAGER: 'Gestione',

	PERMISSIONS_SECTION_ROLES: 'Ruoli',
	PERMISSIONS_SECTION_DERIVED_ROLES: 'Ruoli derivati',
	PERMISSIONS_SECTION_ROLES_PERMISSIONS: 'Permessi dei Ruoli',

	// #region Permissions Management fields
	DETAILS_PERMISSIONS_FIELD_ROLE: 'Ruolo',
	DETAILS_PERMISSIONS_FIELD_ROLE_TITLE: 'Titolo ruolo',
	DETAILS_PERMISSIONS_FIELD_ROLE_EXTERNAL: 'Esterno',
	DETAILS_PERMISSIONS_FIELD_ROLE_LOGIN_REDIRECT_URL: 'Url di reindirizzamento al login',
	DETAILS_PERMISSIONS_FIELD_PARENT_ROLE: 'Ruolo padre',
	DETAILS_PERMISSIONS_FIELD_CHILD_ROLE: 'Ruolo figlio',
	DETAILS_PERMISSIONS_FIELD_RESOURCE: 'Risorsa',
	DETAILS_PERMISSIONS_FIELD_ACTION: 'Azione',
	// #endregion

	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE: 'Nuovo Ruolo',
	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE_RELATION: 'Nuova Ruolo derivato',
	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE_PERMISSION: 'Nuovo Permesso'
};

export default locale;
